export default __webpack_public_path__ + "static/media/Layout_First.71171f9e.jpg";